import SideNav from "./SideNav";
import { Outlet } from "react-router";
import parse from 'html-react-parser';

export default function Layout({ folderMetadata, title, description }) {

  return (
    <div id="main-content" className="main mt-3">
      <div className="container">
          <h1>{title}</h1>
          <p>
            {parse(description)}
          </p>
        <div className="row">
          <SideNav folderMetadata={folderMetadata} />
          <Outlet />
        </div>
      </div>
    </div>
  )
}